// extracted by mini-css-extract-plugin
export default {"content_position":"ListAdmin_content_position__mfIqg","form":"ListAdmin_form__HnLK6","popup_wrap":"ListAdmin_popup_wrap__zR+Dw","content_popup":"ListAdmin_content_popup__CALQP"};